const imageContext = require.context(
  "../assets/images",
  true,
  /\.(png|jpe?g|webp|svg)$/,
);

export const resolveImage = (path) => {
  const relativePath = path.replace("/assets/images/", "./");

  return imageContext(relativePath);
};
